import React from 'react';
import { Navigate } from 'react-router-dom';
import './storyListingFooter.scss';
import './storyListingTable.scss';
import './storyListingCheckboxDropdown.scss';
import Footer from '../Footer/footer';
import Header from '../Header/header';
import { auth as AuthObject } from '../../services/login'
import '../Header/header.scss';
import cookie from '../../cookieHelper/cookie';
import toastNotify from '../../utils/toastNotifier';

import deleteStory from '../../services/deleteStory';
import repostStory from '../../services/repostStory';
import getAllCompanyStories from '../../services/story/getAllCompanyStories';

import PopulateCompanyList from '../CompanyList/companyList';
import getCompanies from '../../services/getCompanyList';
import calculateDateInFormat from '../../utils/calculateDate';
import EmptyScreen from '../../components/EmptyScreen/EmptyScreen';
import withRouter from '../withRouter';
import getFilteredStories from '../../services/story/getFilteredStories';


class AllCompanyStories extends React.Component {
    constructor() {
        super();
        this.state = {
            companyID: '',
            rows: [],
            companyList: [],
            currentCompanyID: '',
            page: 0,
            status: '',
            companies: [],
            platform: '',
            redirectToEdit: false,
            tokencheck: true,
            storyTypeFilter: '',
            storyId: ''
        };
        this.isLoading = false;
        this.page = 0;

        this.page = 0;
        this.getList = {};
        this.statusField = -1;
        this.selectedCompanyID = '';
        this.origin = '';


        this.data = {
            companyId: this.state.companyID,
            status: this.state.status,
            page: this.page,
            size: 10
        }

        this.validateData(this.data);
        this.flag = false;
        // this.doAdminCheck();
    }

    statusMap = {
        0: "Deleted",
        1: "Active",
        2: "Expired",
        3: "Saved as Draft"
    }

    checkAuth = () => {
        AuthObject.authenticate(() => {
            if (cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)) {
                this.setState(() => ({
                    redirectToReferrer: true
                }))
            }
        })
    }

    redirectHandler = () => {
        // console.log("in redirectHandler");  
        this.setState({
            redirect: true
        })
    }

    editRedirectHandler = (storyId) => {
        this.setState({
            redirectToEdit: true,
            storyId : storyId
        })
    }

    setCompanyID = (e) => {
        this.setState({
            companyID: e.target.value
        })
    }

    setStatus = (e) => {

        this.setState({
            status: e.target.value
        })
    }
    setPlatform = (e) => {
        this.setState({
            platform: e.target.value
        })
    }
    setStoryTypeFilter = (e) => {
        this.setState({
            storyTypeFilter: e.target.value
        })
    }

    componentDidUpdate() {
        
        if (this.flag == true) {
            var removeAdminChecks = document.querySelectorAll(".adminCheckHidden");
            console.log("removeAdminChecks.length:", removeAdminChecks.length);
            for (var index = 0; index < removeAdminChecks.length; index++) {
                var admin = removeAdminChecks[index];
                admin.classList.remove("adminCheckHidden");
            }

            var removeAdminData = document.querySelectorAll(".adminDataHidden");
            for (var index = 0; index < removeAdminData.length; index++) {
                var adminData = removeAdminData[index];
                adminData.classList.remove("adminDataHidden");
            }
        }

    }

    componentDidMount() {
        this.refs.iScroll.addEventListener("scroll", () => {
            if (this.refs.iScroll.scrollTop + this.refs.iScroll.clientHeight >= this.refs.iScroll.scrollHeight - 5) {  // Added small buffer
                const data = {
                    companyId: this.state.companyID,
                    status: this.state.status,
                    origin: this.state.platform,
                    storyTypeFilter: this.state.storyTypeFilter,
                    page: this.page++,
                    size: 10,
                    mediaType: "mp4"
                };
                this.loadMoreStories(data);
            }
        });
        this.loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
        console.log("Inside allCompamyStories Function:", this.loginProfileInfo.email);
        // var flag = false;
        var admins = ["triptee@iimjobs.com", "bharat@iimjobs.com", "puneet.pant@iimjobs.com","minisha@iimjobs.com"];
        // var admins = ["test_123@iimjobs.com"];
        console.log(admins.length);
        for (var i = 0; i < admins.length; i++) {
            console.log(admins[i]);
            if (admins[i] === this.loginProfileInfo.email) {
                this.flag = true;
            }
        }
        console.log("flag:", this.flag);
        if (this.flag == true) {
            var removeAdminChecks = document.querySelectorAll(".adminCheckHidden");
            console.log("removeAdminChecks.length:", removeAdminChecks.length);

            // var removeAdminData = document.querySelectorAll(".adminDataHidden");
            // console.log("removeAdminData.length:", removeAdminData.length);

            for (var index = 0; index < removeAdminChecks.length; index++) {
                var admin = removeAdminChecks[index];
                // admin.style.display="table-cell";
                admin.classList.remove("adminCheckHidden");
            }

        }
        let list = {};

        const companyList = async () => {
            let companiesResult = await getCompanies();

            if (!(companiesResult instanceof Error)) {
                if (companiesResult.status.code == "10200"){
                    list = companiesResult.data[0];

                    console.log("companyList: ", list);
                    this.getList = list;
                    // console.log(list.companies.length);
                    // let companyListing = <option>No company Found</option>;
                    // var companyListing = document.createElement('select');
                    if (typeof list === 'undefined') {
                        // console.log("if ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found', code: '' }] });
                    }
                    else if (Object.keys(list).length === 0) {
                        // console.log("else if-1 ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found', code: '' }] });
                    }
                    else if (list.companies.length) {
                        // console.log("else if-2 ran");
                        let teamsFromApi = list.companies.map(item => { return { value: item.id, display: item.companyName, code: item.companyCode } })
                        this.setState({ companies: [{ value: '', display: 'Select Company' }].concat(teamsFromApi) });
                    }
                    else {
                        // console.log("else ran");
                        toastNotify(3, "No companies were found.");
                        this.setState({ companies: [{ value: '', display: 'No Companies Found' }] });
                    }
                }else{
                    toastNotify("3", "Some error occured while fetching companies list")
                }
            }else{
                const response = JSON.parse(companiesResult.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                else{
                    toastNotify("3", "Some error occured while fetching companies list")

                }
            }
        }

        companyList();
    }

    eventHandleClick() {
        var ui = document.querySelector(".profile-menu");
        ui.style.display = "none";
    }

    onSubmit = async (e) => {
        this.statusField = this.state.status
        this.selectedCompanyID = this.state.companyID
        this.origin = this.state.platform
        this.state.page = 0; // reset page on submit
        this.data = {
            companyId: this.state.companyID,
            status: this.state.status,
            origin: this.state.platform,
            storyTypeFilter: this.state.storyTypeFilter,
            page: this.state.page,
            size: 10
        }

        this.validateData(this.data);
    }
    onClearFilter = async (e) => {
        window.location.reload(); // This will completely refresh the page
    }

    validateData = async (data) => {

        data.mediaType = "mp4";// mediaType mp4
        let result = await getFilteredStories(data);

        if (!(result instanceof Error)) {
            if (result.status.code == "10200"){
                let storyList = result.data[0].stories;
                
                // if(typeof storyList === 'undefined'){
                //     return toastNotify(3 , "No Stories Found.");
                // }
                // else if(Object.keys(storyList).length === 0 ){
                //     return toastNotify(3 , "No Stories Found.")
                // }
                        
                if (storyList.length) {
                    let rows = storyList.map((item, index) => {
                        return {
                            storyType: item.storyType,
                            s3Path: item.s3Path,
                            status: item.status,
                            publishOn: item.publishOn,
                            thumbnailUrl: item.thumbnailUrl
                        }
                    })
        
                    this.setState({
                        companyList: storyList,
                        rows: rows,
                        currentCompanyID: this.state.companyID,
                        status: this.statusField
                    })
                }
                else {
                    this.setState({
                        companyList: [],
                        rows: [],
                        currentCompanyID: '',
                        status: ''
                    })
                    toastNotify(3, "No story found");
                }
            }
        } else {
            const response = JSON.parse(result.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
            else {
                toastNotify(3, "Some error occured. Please try again later.")
            }

        }     
    }

    onDelete = async (e, storyId, index) => {
        e.preventDefault();

        try {
            let result = await deleteStory(storyId);

            if(result  && result["status"]==200)
            {
                const companyLists = this.state.companyList;
                const companyListing = this.state.companyList[index];
                companyListing.status = 0;
                companyLists[index] = companyListing;
                toastNotify(1, "Successfully deleted story");
    
                this.setState({
                    companyList: companyLists
                })

            }
            else{
                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
            }


           

        }
        catch (err) {
            console.log(err);
            toastNotify(3, "Couldn't delete story");
        }
    }
    onRepost = async (e, storyId, index) => {
        try {
            let loginProfileInfo = JSON.parse(cookie.getCookie('loginProfileInfo'));
            let createdBy = loginProfileInfo.id;
            let result = await repostStory(storyId, createdBy);

            if(result && result["status"] == 200){
                toastNotify(1, "Successfully reposted story");
                document.getElementById("btnSubmit").click();
            }
            else {
                const response = JSON.parse(result.request.response);
                const code = response?.status?.code;
                if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                }
                toastNotify(3, `Couldn't Repost story : ${result.message}`);
            }
        }
        catch (err) {
            console.log(err);
            toastNotify(3, `Couldn't Repost story : ${err.message}`);
        }
    }

    loadMoreStories = async (data) => {
        // Prevent multiple simultaneous load requests
        if (this.isLoading) return;
        this.isLoading = true;

        try {
            let result = await getFilteredStories(data);

            if (!(result instanceof Error)) {
                if (result.status.code === "10200") {
                    let storyList = result.data[0].stories;

                    if (storyList.length) {
                        let rows = storyList.map((item) => ({
                            storyType: item.storyType,
                            s3Path: item.s3Path,
                            status: item.status,
                            publishOn: item.publishOn,
                            thumbnailUrl: item.thumbnailUrl
                        }));
            
                        let newCompanyList = [...this.state.companyList, ...storyList];
                        let newRows = [...this.state.rows, ...rows];
            
                        this.setState({
                            companyList: newCompanyList,
                            rows: newRows,
                            currentCompanyID: this.state.companyID
                        });
                    } else {
                        toastNotify(3, "No more stories found");
                    }
                } else {
                    toastNotify(3, result.status.message || "Error loading more stories");
                }
            } else {
                const response = result.request ? JSON.parse(result.request.response) : null;
                const code = response?.status?.code;
                if (code === 10411 || code === 10412 || code === 10416 || code === 10417) {
                    this.setState({ tokencheck: false });
                    cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                    cookie.delete_cookie('loginProfileInfo');
                    AuthObject.isAuthenticated = false;
                } else {                
                    toastNotify(3, "Some error occurred. Please try again later.");
                }
            }
        } catch (error) {
            console.error("Error in loadMoreStories:", error);
            toastNotify(3, "An error occurred while loading more stories.");
        } finally {
            this.isLoading = false;
        }
        
    }

    render() {
        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        let toShowPublishType = false;
        if(this.state.companyList){
            toShowPublishType = this.state.companyList.findIndex(x => x.storyType === 2) !== 1;
        }

        if (this.state.redirect) {
            return <Navigate to={'/storyListing'} />
        }
        if(this.state.redirectToEdit){
            return <Navigate to={`/editStory/${this.state.storyId}`} />
        }

        let activeStoryRows = null;
        let activeStoryRowsForDeletedStatus = null;
        let emptyScreen = null;
        let companyName = "";
        let companyCode = "";
        
        if (this.state.companyList && this.state.companyList.length) {
            if (this.selectedCompanyID == '' && this.origin == '' && this.statusField == 0){
                activeStoryRowsForDeletedStatus = (
                    this.state.companyList.map((item, index) => {
                        let videoClassName, imageClassName, buttonClassName, publishButtonClassName, multiSelectOption, companyDetail, repostClassName = "hidden", repostButtonTitle = "", repostDisable = false;
                        if (item.storyType == 1) {
                            videoClassName = "videoComponent hidden";
                            imageClassName = "imageComponent";
                        }
                        else if (item.storyType == 2) {
                            videoClassName = "videoComponent";
                            imageClassName = "imageComponent hidden";
                        }
                        if (item.status == 1) {
                            buttonClassName = "btn-default color_danger";
                            multiSelectOption = "hidden";
                        }
                        else if (item.status == 3) {
                            buttonClassName = "btn-default color_danger";
                            multiSelectOption = "story-select";
                        }
                        else {
                            buttonClassName = "hidden";
                            multiSelectOption = "hidden";
                            repostClassName = "btn-default repost-btn";
                            if(item.newStoryId && item.newStoryId.length > 0){
                                repostClassName += " disabled";
                                repostButtonTitle = "Already Reposted";
                                repostDisable = true;
                            }
                        }
                        if (this.state.companies.length) {
                            companyDetail = this.state.companies.filter(function (el) {
                                if (el['value'] === item.companyId) {
                                    return el;
                                }
                            })
                            if(companyDetail.length){
                                companyName = companyDetail[0].display;
                                companyCode = companyDetail[0].code;
                            }
                        }
                        return (
                            <tr key={index} rowindex={index}>
                                <td>
                                    <p>{item.companyId}</p>
                                </td>
                                <td>
                                    <p>{item.centralCompanyId}</p>
                                </td>
                                <td>
                                    <p>{item.companyName}</p>
                                </td>
                                <td>
                                    <p>{item.storyId}</p>
                                </td>
                                <td>
                                    <div className={videoClassName}>
                                        <video width="200" height="200" controls loop>
                                            <source src={item.s3Path} type="video/mp4" />
                                        </video>
                                    </div>
                                    <div className={imageClassName}>
                                        <img src={item.s3Path} />
                                    </div>
                                </td>
                                <td>
                                    {item.thumbnailUrl && (
                                        <img src={item.thumbnailUrl} alt="Thumbnail" style={{ width: '190px', height: '200px' }} />
                                    )}
                                </td>
                                {toShowPublishType && (<td> <p>{item.publishType == 2 ? 'reel' : 'story'}</p> </td>) }
                                <td>
                                    <p>{this.statusMap[item.status]}</p>
                                </td>
                                {/* <td>
                                    <button className={buttonClassName} onClick={(e) => this.editRedirectHandler(item.storyId)}>Edit</button>
                                    <button className={buttonClassName} onClick={(e) => this.onDelete(e, item.storyId, index)}>Delete</button>
                                    <button className={repostClassName} title={repostButtonTitle} disabled={repostDisable} onClick={(e) => this.onRepost(e, item.storyId, index)}>Repost</button>
                                </td> */}
                                <td>
                                    <p>{item.publishOn}</p>
                                </td>
                                <td className="adminDataHidden">
                                    <p>{calculateDateInFormat(item.createdOn)}</p>
                                </td>
                                <td className="adminDataHidden">
                                    <p>{calculateDateInFormat(item.deletedOn)}</p>
                                </td>
                                <td className="adminDataHidden">
                                    <p>{calculateDateInFormat(item.expiryOn)}</p>
                                </td>
                                <td>
                                    <p>{item.totalClapCount}</p>
                                </td>
                                <td>
                                    <p>{item.totalViewCount}</p>
                                </td>
                                <td>
                                    <p>{item.totalScrollCount}</p>
                                </td>
                            </tr>
                        )
                    })
                )
            }else{
                activeStoryRows = (
                    this.state.companyList.map((item, index) => {
                        let videoClassName, imageClassName, buttonClassName, publishButtonClassName, multiSelectOption, companyDetail, repostClassName = "hidden", repostButtonTitle = "", repostDisable = false;
                        if (item.storyType == 1) {
                            videoClassName = "videoComponent hidden";
                            imageClassName = "imageComponent";
                        }
                        else if (item.storyType == 2) {
                            videoClassName = "videoComponent";
                            imageClassName = "imageComponent hidden";
                        }
                        if (item.status == 1) {
                            buttonClassName = "btn-default color_danger";
                            multiSelectOption = "hidden";
                        }
                        else if (item.status == 3) {
                            buttonClassName = "btn-default color_danger";
                            multiSelectOption = "story-select";
                        }
                        else {
                            buttonClassName = "hidden";
                            multiSelectOption = "hidden";
                            repostClassName = "btn-default repost-btn";
                            if(item.newStoryId && item.newStoryId.length > 0){
                                repostClassName += " disabled";
                                repostButtonTitle = "Already Reposted";
                                repostDisable = true;
                            }
                        }
                        if (this.state.companies.length) {
                            companyDetail = this.state.companies.filter(function (el) {
                                if (el['value'] === item.companyId) {
                                    return el;
                                }
                            })
                            if(companyDetail.length){
                                companyName = companyDetail[0].display;
                                companyCode = companyDetail[0].code;
                            }
                        }
                        return (
                            <tr key={index} rowindex={index}>
                                <td>
                                    <p>{item.companyId}</p>
                                </td>
                                <td>
                                    <p>{item.centralCompanyId}</p>
                                </td>
                                <td>
                                    <p>{item.companyName}</p>
                                </td>
                                <td>
                                    <p>{item.storyId}</p>
                                </td>
                                <td>
                                    <div className={videoClassName}>
                                        <video width="200" height="200" controls loop>
                                            <source src={item.s3Path} type="video/mp4" />
                                        </video>
                                    </div>
                                    <div className={imageClassName}>
                                        <img src={item.s3Path} />
                                    </div>
                                </td>
                                <td>
                                    {item.thumbnailUrl && (
                                        <img src={item.thumbnailUrl} alt="Thumbnail" style={{ width: '190px', height: '200px' }} />
                                    )}
                                </td>
                                {toShowPublishType && (<td> <p>{item.publishType === 2 ? 'reel' : 'story'}</p> </td>) }
                                <td>
                                    <p>{this.statusMap[item.status]}</p>
                                </td>
                                {/* <td>
                                    <button className={buttonClassName} onClick={(e) => this.editRedirectHandler(item.storyId)}>Edit</button>
                                    <button className={buttonClassName} onClick={(e) => this.onDelete(e, item.storyId, index)}>Delete</button>
                                    <button className={repostClassName} title={repostButtonTitle} disabled={repostDisable} onClick={(e) => this.onRepost(e, item.storyId, index)}>Repost</button>
                                </td> */}
                                <td>
                                    <p>{item.publishOn}</p>
                                </td>
                                <td className="adminDataHidden">
                                    <p>{calculateDateInFormat(item.createdOn)}</p>
                                </td>
                                <td className="adminDataHidden">
                                    <p>{calculateDateInFormat(item.expiryOn)}</p>
                                </td>
                                <td>
                                    <p>{item.totalClapCount}</p>
                                </td>
                                <td>
                                    <p>{item.totalViewCount}</p>
                                </td>
                                <td>
                                    <p>{item.totalScrollCount}</p>
                                </td>
                            </tr>
                        )
                    })
                )
            }
            
            
        } else{
            activeStoryRows = null;
            activeStoryRowsForDeletedStatus = null;
            emptyScreen = (
                <EmptyScreen item="Stories" />
            )
        }

        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick} ref="iScroll" style={{ height: "100vh", overflow: "auto" }}>
                <Header />
                <section className="listing_header">
                    <h1>All Stories</h1>
                    {/* <div className="wrapperButton" onClick={this.redirectHandler}>
                        Add New Story
                </div> */}
                    <div className="wrapper">
                        <div className="wrapperForm">
                            <div className="form-group">
                                <label>Company List:</label>
                                <select onChange={(e) => this.setCompanyID(e)}>
                                    {this.state.companies.map((item) => <option key={item.value} value={item.value}>{item.display}</option>)}
                                </select>
                                <span>&emsp;<b>OR</b>&emsp;</span>
                                <label>Status:</label>
                                <select onChange={(e) => this.setStatus(e)} name="status" className="ele_spacing2">
                                    <option>Select Status</option>
                                    <option value="0">Deleted</option>
                                    <option value="1">Active</option>
                                    <option value="2">Expired</option>
                                    <option value="3">Saved as Draft</option>
                                </select>

                                <div style={{marginTop:'10px',display:'inline-block',width:'40%'}}>
                                    <span><b>OR</b>&emsp;</span>
                                    <label>Publish On:</label>
                                    <select onChange={(e) => this.setPlatform(e)} name="platform">
                                        <option value="">Select Platform </option>
                                        <option value="iimjobs">iimjobs</option>
                                        <option value="hirist">hirist</option>
                                    </select>
                                </div>
                                <div style={{marginTop:'10px',display:'inline-block',width:'40%'}}>
                                    <span><b>OR</b>&emsp;</span>
                                    <label>Story Type Filter:</label>
                                    <select onChange={(e) => this.setStoryTypeFilter(e)} name="storyTypeFilter">
                                        <option value="">Select Story Type Filter</option>
                                        <option value="reel">Reels</option>
                                        <option value="story">Stories</option>
                                    </select>
                                </div>

                                <button type="submit" id="btnSubmit" className="btn-default" onClick={(e) => this.onSubmit(e)}>GO</button>
                                <button style={{background: "#9E9E9E", color: "#424242", fontWeight: "bold"}} type="reset" id="btnClearFilter" className="btn-default btn-clear-filter" onClick={(e) => this.onClearFilter(e)}>Clear Filter</button>
                            </div>
                        </div>

                        <div className="wrapperTable allStoryTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                {this.selectedCompanyID == '' && this.origin == '' && this.statusField == 0 ? 
                                    <tbody>
                                        <tr className="table-header">
                                            <th className="table_header">Company ID</th>
                                            <th className="table_header">Centralised Company ID</th>
                                            <th className="table_header">Company Name</th>
                                            <th className="table_header">Story ID</th>
                                            <th className="table_header">Story</th>
                                            <th className="table_header">Thumbnail</th>
                                            {toShowPublishType && (<th className="table_header">Publish Type</th>)}
                                            <th className="table_header">Status</th>
                                            {/* <th className="table_header">Actions</th> */}
                                            <th className="table_header">Published On</th>
                                            <th className="table_header adminCheckHidden" >Created On</th>
                                            <th className="table_header adminCheckHidden">Deleted On</th>
                                            <th className="table_header adminCheckHidden">Expiry</th>
                                            <th className="table_header">Clap Count</th>
                                            <th className="table_header">View Count</th>
                                            <th className="table_header">Scroll Count</th>
                                        </tr>
                                        {activeStoryRowsForDeletedStatus}
                                    </tbody> :
                                    <tbody>
                                        <tr className="table-header">
                                            <th className="table_header">Company ID</th>
                                            <th className="table_header">Centralised Company ID</th>
                                            <th className="table_header">Company Name</th>
                                            <th className="table_header">Story ID</th>
                                            <th className="table_header">Story</th>
                                            <th className="table_header">Thumbnail</th>
                                            {toShowPublishType && (<th className="table_header">Publish Type</th>)}
                                            <th className="table_header">Status</th>
                                            {/* <th className="table_header">Actions</th> */}
                                            <th className="table_header">Published On</th>
                                            <th className="table_header adminCheckHidden" >Created On</th>
                                            <th className="table_header adminCheckHidden">Expiry</th>
                                            <th className="table_header">Clap Count</th>
                                            <th className="table_header">View Count</th>
                                            <th className="table_header">Scroll Count</th>
                                        </tr>
                                        {activeStoryRows}
                                    </tbody>
                                }   
                            </table>
                            {emptyScreen}
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(AllCompanyStories);    